import { render, staticRenderFns } from "./trustTeachPop.vue?vue&type=template&id=b64ecf54&scoped=true"
import script from "./trustTeachPop.vue?vue&type=script&lang=js"
export * from "./trustTeachPop.vue?vue&type=script&lang=js"
import style0 from "./trustTeachPop.vue?vue&type=style&index=0&id=b64ecf54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64ecf54",
  null
  
)

export default component.exports